import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import FlightExampleItem from "./flightExampleItem"
import { Href } from "../utils/helper"

const SampleAirfareToJapan = ({ blok }) => {

  return (
    <section {...storyblokEditable(blok)} className="destinations-section max-w-screen-xl mx-auto my-12">
      <h2 className="flex justify-center font-bold text-3xl md:text-4xl my-6 md:my-10">{blok.title}</h2>
      <div className="text-center" dangerouslySetInnerHTML={{ __html: renderRichText(blok.description) }} />
      <div className="grid gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center">
        {blok.japanAirfareExamples.map(blok => (<FlightExampleItem key={blok._uid} blok={blok} />))}
      </div>
      <div className="flex justify-center py-10">
        <a href={Href(blok.ctaUrl)} className="text-lg text-blue-700 border-2 border-blue-700 rounded-lg py-2 px-8 flex items-center">
          {blok.ctaText}
          <img className="w-8 h-3 align-middle ml-4" src="/icons/arrow-right-blue.svg" alt="Arrow right" />
        </a>
      </div>
    </section>
  )
}

export default SampleAirfareToJapan
